import { createSelector } from 'reselect';
import { GiveawayPopups } from 'swag-common/constants/giveaway.constants';
import { shownPopupSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
export const isGiveawayProductImagePopupShownSelector = createSelector(shownPopupSelector, shownPopup => shownPopup === GiveawayPopups.GIVEAWAY_LINK_PRODUCT_IMAGE_POPUP);